import { isValidEmail } from '../../services/UtilService';
import { getTest } from '../../apis/loginApi';

class SamplePageController {
  initialState = {
    email: 'a@b.com',
    name: '',
    position: '',
    age: 0,
  };

  constructor(
    { store, updateStore },
    modalService,
    validateService,
    navigate,
    [gridRef],
    { valueObj, setValueObj }
  ) {
    this.store = store;
    this.updateStore = updateStore;
    this.modalService = modalService;
    this.validateService = validateService;
    this.navigate = navigate;
    this.gridRef = gridRef;
    this.valueObj = { ...this.initialState, ...valueObj };
    this.setValueObj = setValueObj;
  }

  async getTest() {
    this.navigate('/sample');
  }

  // 조회
  async fnSearch() {
    const url = '/member/user/list.do';
    const param = {
      entSn: 'ME00000001',
    };

    this.gridRef.current.doQuery(url, param);
  }

  async fnValidate() {
    const searchParam = {
      name: null,
      email: 'aaaa',
      position: '사원',
      age: 0,
    };

    const validationRules = {
      name: { presence: true },
      email: { presence: true, email: true },
      position: { presence: true, length: { minimum: 3 } },
      age: {
        presence: true,
        numericality: { onlyInteger: true, greaterThan: 0 },
      },
    };

    const altKey = {
      name: '이름',
      age: '나이',
    };

    if (
      this.validateService.validateJsCall(searchParam, validationRules, altKey)
    ) {
      return;
    }
  }

  // 저장
  async fnSave() {}

  // 버튼
  async btnClick() {
    this.modalService.errorAlert('에러메세지', () => {
    });
  }

  async fnValidateEmail(email) {
    if (!isValidEmail(email)) {
      this.modalService.errorAlert('이메일 형식이 아닙니다.');
      this.setValueObj({ ...this.valueObj, email: '' });
      return;
    } else {
    }
  }

  async valueObjChange(model, value) {
    this.setValueObj({ ...this.valueObj, [model]: value });
  }

  async gridHeaderClick(col) {
  }

  async gridCellClick(row, col) {
  }
}

export default SamplePageController;
